import { type Column, SupTracker, SupText, SupChip, SupTooltip } from "@repo/core-ui";
import { SupTxStatus } from "@repo/ui-widgets";
import { formatDistanceToNow } from "date-fns";
import Link from "next/link";

import { formatHash, formatAddress } from "@/utils";
import React from "react";

import type { TRow } from "../Table/types";

export const columns: Column<TRow>[] = [
  {
    field: "status",
    headerCellClassName: "pl-4",
    cellClassName: "cursor-pointer pl-4",
    headerName: "TX STATUS",
    minWidth: 150,
    renderCell: row => <SupTxStatus value={row.status} />,
  },
  {
    field: "type",
    cellClassName: "cursor-pointer",
    headerName: "TX TYPE",
    minWidth: 150,
    renderCell: row => <SupTracker variant="primary">{row.type}</SupTracker>,
  },
  {
    field: "hash",
    cellClassName: "cursor-pointer",
    headerName: "SOURCE HASH",
    minWidth: 150,
    renderCell: row => (
      <SupTooltip unmount portal color="primary" content={row.hash}>
        <SupText as="span" variant="body1" family="sans" className="uppercase">
          {formatHash(row.hash)}
        </SupText>
      </SupTooltip>
    ),
  },
  {
    field: "sender",
    cellClassName: "cursor-pointer",
    headerName: "SENDER",
    minWidth: 180,
    renderCell: row => (
      <SupTooltip unmount portal color="primary" content={row.sender}>
        <Link
          href={`https://scan.superform.xyz/address/${row.sender}`}
          target="_blank"
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <SupText as="span" variant="body1" family="sans" className="uppercase underline">
            {formatAddress(row.sender)}
          </SupText>
        </Link>
      </SupTooltip>
    ),
  },
  {
    field: "sourceChain",
    cellClassName: "cursor-pointer",
    headerName: "SOURCE CHAIN",
    minWidth: 150,
    valueGetter: row => row.sourceChain.name,
    renderCell: row =>
      row.sourceChain.name ? <SupChip small icon={row.sourceChain.logo} label={row.sourceChain.name} type="square" iconType="square" border borderStyle="dashed" /> : "N/A",
  },
  {
    field: "targetChain",
    cellClassName: "cursor-pointer",
    headerName: "TARGET CHAIN",
    minWidth: 150,
    valueGetter: row => row.targetChain.name,
    renderCell: row =>
      row.targetChain.name ? <SupChip small icon={row.targetChain.logo} label={row.targetChain.name} type="square" iconType="square" border borderStyle="dashed" /> : "N/A",
  },
  {
    field: "targetVault",
    cellClassName: "cursor-pointer",
    headerName: "TARGET VAULT",
    minWidth: 150,
  },
  {
    cellClassName: "cursor-pointer",
    field: "timestamp",
    headerName: "AGE",
    minWidth: 180,
    renderCell: row => (
      <SupText variant="body1" family="sans" className="uppercase">
        {formatDistanceToNow(row.timestamp)}
      </SupText>
    ),
  },
];
